module.exports = __webpack_public_path__ + "img/c07_unithorseman_Normal_ua.a0f5452a.webp";